import React, { useState } from 'react';

import { Text } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { RadioButton } from './RadioButton';
import { RadioButtonList } from './RadioButtonList';

const OPTIONS = [
  { value: 'a', label: 'Radio label' },
  { value: 'b', label: 'Radio label' },
  { value: 'c', label: 'Radio label' },
];

export function RadioButtonShowcase() {
  const [selectedSmall, setSelectedSmall] = useState('a');
  const [selectedLarge, setSelectedLarge] = useState('b');

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Radio Button - etats Figma, tailles small/large et liste single-select.
      </Text>

      <Row gap="spacing.general.x3">
        <RadioButton label="Radio label" state="enabled" />
        <RadioButton label="Radio label" selected state="enabled" />
      </Row>

      <Row gap="spacing.general.x3">
        <RadioButton label="Radio label" state="hover" />
        <RadioButton label="Radio label" selected state="hover" />
      </Row>

      <Row gap="spacing.general.x3">
        <RadioButton label="Radio label" state="pressed" />
        <RadioButton label="Radio label" selected state="pressed" />
      </Row>

      <Row gap="spacing.general.x3">
        <RadioButton label="Radio label" state="focus" />
        <RadioButton label="Radio label" selected state="focus" />
      </Row>

      <Row gap="spacing.general.x3">
        <RadioButton label="Radio label" state="disabled" />
        <RadioButton label="Radio label" selected state="disabled" />
      </Row>

      <Row gap="spacing.general.x6">
        <RadioButtonList options={OPTIONS} selectedValue={selectedSmall} onChange={setSelectedSmall} size="small" />
        <RadioButtonList options={OPTIONS} selectedValue={selectedLarge} onChange={setSelectedLarge} size="large" />
      </Row>
    </Column>
  );
}
